import z from "zod";

const envSchema = z.object({
  VITE_API_URL: z.string().min(1),
  VITE_PUBLIC_URL: z.string().min(1),
  VITE_DEFAULT_ORGANIZATION_SLUG: z.string().min(1),
  VITE_DEFAULT_PROJECT_SLUG: z.string().min(1),
});

export type Env = z.infer<typeof envSchema>;

export const env = envSchema.parse(import.meta.env);
